module.exports = __webpack_public_path__ + "static/media/patrick.eeb01e38.svg";